import { CarePlanProblem } from '@seen/core/models/conditions/CarePlanProblem'
import type { ExtendedCondition } from '@seen/core/models/conditions/ExtendedCondition'
import { Badge, TypographySubtle } from '@seen/ui'
import type { JSX } from 'react'

export function ConditionDisplay({
  condition,
}: {
  condition: ExtendedCondition
}): JSX.Element {
  return (
    <div>
      <div className="flex items-center gap-2">
        <h5>{condition.title}</h5>{' '}
        <Badge variant="outline" className="rounded-full">
          {condition.categoryDisplay}
        </Badge>
        <Badge variant="outline" className="text-xs">
          {condition.clinicalStatus}
        </Badge>
      </div>
      {condition instanceof CarePlanProblem && (
        <TypographySubtle>{condition.note}</TypographySubtle>
      )}
    </div>
  )
}
